// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-Breach-BreachNews----BreachNews-module---wrapper---3NoAo","newsWrapper":"src-components-Breach-BreachNews----BreachNews-module---newsWrapper---2hjL8","stories":"src-components-Breach-BreachNews----BreachNews-module---stories---36mwA","timeline":"src-components-Breach-BreachNews----BreachNews-module---timeline---1yMmf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Breach/BreachNews/BreachNews.module.css
// module id = 726
// module chunks = 28901507966785